module.exports = __webpack_public_path__ + "img/1 (85).9897ffb1.png";